import { forwardRef } from 'react';
import Select, { type GroupBase, type Props, type StylesConfig } from 'react-select';

type MultiSelectProps<
  Option = unknown,
  IsMulti extends boolean = true,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = Props<Option, IsMulti, Group>;

const selectedOptionStyles = {
  backgroundColor: 'var(--falcon-primary)',
  color: 'var(--falcon-primary-text-emphasis)'
};

const MultiSelect = forwardRef<
  Select<unknown, true, GroupBase<unknown>>,
  MultiSelectProps
>(({ options, placeholder, styles, ...rest }, ref) => {
  const mergedStyles: StylesConfig<unknown, true> = {
    ...styles,
    option: (base, state) => {
      const fromProps = styles?.option?.(base, state) ?? base;
      if (!state.isSelected) return fromProps;
      return {
        ...fromProps,
        ...selectedOptionStyles,
        ':active': {
          ...fromProps[':active'],
          backgroundColor: selectedOptionStyles.backgroundColor
        }
      };
    }
  };

  return (
    <Select
      ref={ref}
      closeMenuOnSelect={false}
      isMulti
      options={options}
      placeholder={placeholder}
      classNamePrefix="react-select"
      {...rest}
      styles={mergedStyles}
    />
  );
});

MultiSelect.displayName = 'MultiSelect';

export default MultiSelect;
